<template>
  <div>
    <BaseTooltip :tooltip="tooltip || localStorage.translations.pages.common.buttons['dobavit']">
      <v-btn v-if="minimal" icon :disabled="disabled" @click="selectFile()">
        <BaseIcon color="#277faf" icon="button-upload"/>
      </v-btn>
      <BaseButton
        v-else
        icon-color="#f2f2f2"
        default_icon="button-upload"
        :disabled="disabled"
        @click="selectFile()"
        :text="tooltip || localStorage.translations.pages.common.buttons['dobavit']"
      >
        <IconFileFormat
          slot="append"
          :jpg="accept.indexOf('jpg') > 0 || accept.indexOf('jpeg') > 0"
          :png="accept.indexOf('png') > 0"
          :pdf="accept.indexOf('pdf') > 0"
        />
      </BaseButton>
    </BaseTooltip>
    <input
      style="display: none"
      type="file"
      id="file"
      ref="file"
      :multiple="multiple"
      :accept="'.' + accept.join(', .')"
      v-on:change="onHandleFileUpload"
    />
  </div>
</template>

<script>
import {mapActions} from "vuex";
import IconFileFormat from "components/icons/IconFileFormat";
import BaseIcon from "components/base/BaseIcon";

export default {
  name: "UploadFile",
  components: {BaseIcon, IconFileFormat},
  props: {
    disabled: Boolean,
    tooltip: {
      type: String,
      default: null
    },
    accept: {
      type: Array,
      default: () => {
        return ['jpg', 'jpeg', 'png', 'pdf']
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    minimal: {
      type: Boolean,
      default: true
    },
    onLoad: {},
    externalData: {
      type: [Boolean, Number, String, Object, Array],
      default: null,
    },
    useCase: {
      type: String,
      default: 'cover'
    }
  },
  data: () => ({}),
  computed: {},
  methods: {
    ...mapActions(['uploadFile', 'onLoadingAnimationFullPage']),
    selectFile() {
      if (this.$refs.file) this.$refs.file.click()
    },
    async onHandleFileUpload(e) {
      this.onLoadingAnimationFullPage({value: true})
      let list = []
      const filesUpload = e.target.files
      for (let file of filesUpload) {
        let formData = new FormData()
        formData.append('file', file)
        await this.uploadFile({data: formData, use_case: this.useCase})
          .then(res => {
            file.url = res.data.url
            list.push(file)
          })
      }
      if (this.onLoad) this.onLoad(list, this.externalData)
      this.onLoadingAnimationFullPage({value: false})
    }
  }
}
</script>